// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__TvtZu","list":"FieldCheckboxGroup_list__Fc6VU","twoColumns":"FieldCheckboxGroup_twoColumns__3zU8t","item":"FieldCheckboxGroup_item__2PngD"};